
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import AdminPage from './pages/AdminPage/AdminPage';
import FarmerPage from './pages/FarmerPage/FarmerPage';
import InspectorPage from './pages/InspectorPage/InspectorPage';
import DistributorPage from './pages/DistributorPage/DistributorPage';
import RetailerPage from './pages/RetailerPage/RetailerPage';
import HomePage from './pages/HomePage/HomePage';
import Navbar from './components/NavBar/Navbar';
import BatchDetailsPage from './pages/BatchDetailsPage/BatchDetailsPage';
import GamePage from './pages/GamePage/GamePage';
import LeaderboardsPage from './pages/LeaderboardsPage/LeaderboardsPage';
import './App.css';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState('');

  const handleLogin = (role) => {
    setIsLoggedIn(true);
    setUserRole(role);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserRole('');
  };

  useEffect(() => {
    const handleAccountsChanged = (accounts) => {
      if (accounts.length === 0) {
        handleLogout();
      } else {
        window.location.reload();
      }
    };

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.off('accountsChanged', handleAccountsChanged);
      }
    };
  }, []); 

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        
        {/* Navigation Bar */}
        <Navbar isLoggedIn={isLoggedIn} userRole={userRole} handleLogout={handleLogout} />

        {/* Main Content */}
        <Switch>
          <Route path="/login" render={(props) => <LoginPage {...props} onLogin={handleLogin} />} />
          <Route path="/admin" component={AdminPage} />
          <Route path="/farmer" component={FarmerPage} />
          <Route path="/inspector" component={InspectorPage} />
          <Route path="/distributor" component={DistributorPage} />
          <Route path="/retailer" component={RetailerPage} />

          <Route path="/batch-details/:id" component={BatchDetailsPage} />
          <Route path="/batch-details" component={BatchDetailsPage} />
          <Route path="/game" component={GamePage} />
          <Route path="/leaderboards" component={LeaderboardsPage} />
          <Route path="/" component={HomePage} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;